module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aBM35"))).then(() => module.bundle.root('d0iPb'));